// extracted by mini-css-extract-plugin
export default {"stand":"Stand_stand__5cTs5","inputs":"Stand_inputs__aM+PK","buttons":"Stand_buttons__5UR27","checkboxes":"Stand_checkboxes__Eo0PC"};